import React from 'react';

import { createRoot } from 'react-dom/client';

import PohModal, { IPohModalProps } from './Modal';
import PohButton, { ButtonSize, ButtonVariant } from '../Button';
import ConfirmModal2 from './ConfirmModal2';

export function showModal(modalProps: IPohModalProps): { closeModal: () => void } {
  const div = document.createElement('div');
  document.body.appendChild(div);
  const root = createRoot(div);
  const handleClose = () => {
    if (modalProps.onClose) {
      modalProps.onClose();
    }
    root.unmount();
  };

  root.render(<PohModal {...modalProps} onClose={handleClose} />);

  return { closeModal: handleClose };
}

/**
 * Модалка подтверждения
 * @param confirmText
 * @param cancelText
 * @param showCancel
 * @param showConfirm
 * @param onConfirm
 * @param onCancel
 * @param modalProps
 * @returns {Promise<unknown>}
 */

interface IConfirmModalArgs extends IPohModalProps {
  confirmText?: string;
  cancelText?: string;
  showCancel?: boolean;
  showConfirm?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}
export function confirmModal(props: IConfirmModalArgs | string): Promise<boolean> {
  const {
    confirmText = 'Хорошо',
    cancelText = 'Отмена',
    showCancel = true,
    showConfirm = true,
    onConfirm = () => {},
    onCancel = () => {},
    ...modalProps
  } = typeof props === 'string' ? {} : props;

  if (typeof props === 'string') {
    modalProps.children = props;
  }

  return new Promise((resolve) => {
    showModal({
      size: 'sm',
      backdrop: true,
      closeOnBackdrop: true,
      keyboard: false,

      footer: (closeModalCB: any) => (
        <>
          {showCancel && (
            <PohButton
              variant={ButtonVariant.Secondary}
              onClick={() => {
                resolve(false);
                onCancel();
                closeModalCB();
              }}
            >
              {cancelText}
            </PohButton>
          )}
          {showConfirm && (
            <PohButton
              variant={ButtonVariant.Primary}
              onClick={() => {
                resolve(true);
                onConfirm();
                closeModalCB();
              }}
              style={{ zIndex: 1 }}
              autoFocus
              type="submit"
            >
              {confirmText}
            </PohButton>
          )}
        </>
      ),
      ...modalProps,
    });
  });
}

export const confirmModal2 = (content: React.ReactNode): Promise<boolean> => {
  return new Promise((res) => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    const handleClose = () => {
      const root = createRoot(div);
      root.unmount();
      res(false);
    };

    const root = createRoot(div);

    root.render(
      <ConfirmModal2 onClose={handleClose}>
        <p className="p-2 px-3 my-2">{content}</p>
        <footer className="p-2 px-3 d-flex flex-row-reverse justify-content-end">
          <PohButton
            size={ButtonSize.Small}
            variant={ButtonVariant.Primary}
            className="ms-2"
            onClick={() => {
              res(true);
              handleClose();
            }}
          >
            Ок
          </PohButton>
          <PohButton
            size={ButtonSize.Small}
            onClick={() => {
              res(false);
              handleClose();
            }}
            className="ms-auto"
          >
            Отмена
          </PohButton>
        </footer>
      </ConfirmModal2>,
    );
  });
};
